// extracted by mini-css-extract-plugin
module.exports = {"Avatars":"profileSettings_Avatars__1qTHE","userUpload":"profileSettings_userUpload__Iase-"};